import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { X_SKIP_ALERT } from '../constants/http-headers';
import { EnvironmentService } from './environment.service';
import { FooterService } from './footer.service';

const isSessionExpiredUrl = '/sessionexpired/isSessionExpired.html';

/**
 * This service is used as part of an APP_INITIALIZER to clean up any expired session information.
 */
@Injectable({
  providedIn: 'root'
})
export class StartupService {
  constructor(
    private http: HttpClient,
    private environmentService: EnvironmentService,
    private footerService: FooterService,
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth
  ) {}

  init(): Observable<[boolean, string]> {
    const isSessionExpiredObservable = this.http
      .get<boolean>(isSessionExpiredUrl, {
        headers: {
          [X_SKIP_ALERT]: '1'
        }
      })
      .pipe(
        tap((isSessionExpired) => {
          if (isSessionExpired) {
            this.clearCachedAuth();
          }
        }),
        catchError(() => {
          this.clearCachedAuth();

          return of(true);
        })
      );

    const getReleaseNumberObservable = this.footerService.getReleaseNumber();

    return forkJoin([isSessionExpiredObservable, getReleaseNumberObservable]);
  }

  private clearCachedAuth() {
    localStorage.removeItem(this.environmentService.currentUserLocalStorageKey);
    this.oktaAuth?.tokenManager.clear();
  }
}
